import React from "react";
import "./SingleEndCourse.css";
function SingleEndCourse() {
  return (
    <div className="card" style={{ backgroundImage: "url(./img/last1.png)" }}>
      <h3>Join Now To Start Learning</h3>
      <p>Enroll now to the most popular courses and get a certificate</p>
      <button> Join</button>
    </div>
  );
}

export default SingleEndCourse;
